module.exports = __webpack_public_path__ + "media/images/top-service-04-d0e8be5d4e04d3b82cdb25ff4ad5463a.jpg";